import React from 'react';
import './styles.css';

export const SocialIcon = ({iconClass, destinationUrl, fontColor}) => (
    <a href={destinationUrl} target='_blank' rel="noopener noreferrer">
        <i style={{color: fontColor}}
           className={`${iconClass} + social-icon`}/>
    </a>
);